import { Bets } from '../../../config/bets';
import { useGameSelector } from '../../GameStore';

import { AutoplayLimits, GetAutoPlayBetType } from './types';

export const useCrashAutoplaySlice = {
  isInProgress: (betId: Bets): boolean => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.isInProgress[betId]);
  },
  isOpen: (betId: Bets): boolean => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.isOpen[betId]);
  },
  getRemainingCount: (betId: Bets): number => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.roundsLeft[betId]);
  },
  getSavedBet: (betId: Bets): GetAutoPlayBetType | null => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.savedBet[betId]);
  },
  isLaunchedMidRound: (betId: Bets): boolean => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.isLaunchedMidRound[betId]);
  },
  getAutoplayLimits: (betId: Bets): AutoplayLimits => {
    return {
      singleWinLimit: useGameSelector(({ crashAutoplay }) => crashAutoplay.singleWinLimit[betId]),
      balanceDecreaseLimit: useGameSelector(({ crashAutoplay }) => crashAutoplay.balanceDecreaseLimit[betId]),
      balanceIncreaseLimit: useGameSelector(({ crashAutoplay }) => crashAutoplay.balanceIncreaseLimit[betId]),
    };
  },
  getIsThisRoundOnly: (betId: Bets): boolean => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.isThisRoundOnly[betId]);
  },
  getInfiniteAutoplayEnabled: (betId: Bets): boolean | null => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.isEnabled[betId]);
  },
  getAutoplayRoundsOptions: (betId: Bets): number[] => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.roundsOptions[betId]);
  },
  getAutoplayRoundsAddons: (betId: Bets): number[] => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.roundsAddons[betId]);
  },
  getAutoplayMaxRoundsLimit: (betId: Bets): number => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.maxRoundsLimit[betId]);
  },
  getTotalRounds: (betId: Bets): number => {
    return useGameSelector(({ crashAutoplay }) => crashAutoplay.totalRounds[betId]);
  },
};
